const GL = {
  ibanLength: 18,
};
export { GL };
